import _ from "lodash";

import { AxiosError } from "axios";
import { useEffect, useMemo } from "react";

import { addInspectedItemsToProject } from "../services/reportService";

import logger from "../services/logService";
import useProjectDetails from "./useProjectDetails";

const useInspectedItemIDUpdate = (inspectedItems: string[]) => {
	const { projectDetails } = useProjectDetails();

    const filteredInspectedItems = useMemo(() => {
        return inspectedItems ? inspectedItems.filter((item) => item) : [];
    }, [inspectedItems]);

    useEffect(() => {
        const controller = new AbortController();

        if (!projectDetails) {
            return;
        }

        if (filteredInspectedItems.length === 0) {
            return;
        }

        if (_.isEqual(projectDetails.inspectedItemIDs, filteredInspectedItems)) {
            return;
        }

        addInspectedItemsToProject(projectDetails?._id, filteredInspectedItems, controller.signal)
        .catch((error) => error instanceof AxiosError ? null : logger.log(error));

        return () => controller.abort();
    }, [filteredInspectedItems, projectDetails]);
};

export default useInspectedItemIDUpdate;